<template>
    <div>
        <v-dialog persistent v-model="show">

            <v-card>
                <v-card-title>Reset Password Form</v-card-title>
                <v-card-text>
                    <v-form v-model="formSetting.valid">
                        <v-text-field v-model="form.password" type="password" :rules="validatorSetting.password"
                            label="Password" outlined :append-icon="formSetting.showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="formSetting.showPassword ? 'text' : 'password'" hint="At least 6 characters"
                            :disabled="loading"
                            @click:append="formSetting.showPassword = !formSetting.showPassword"></v-text-field>
                        <v-text-field v-model="form.confirmPassword" type="password" :rules="validatorSetting.password"
                            label="Confirm Password"
                            :append-icon="formSetting.showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="formSetting.showConfirmPassword ? 'text' : 'password'" hint="At least 6 characters"
                            :disabled="loading"
                            @click:append="formSetting.showConfirmPassword = !formSetting.showConfirmPassword"
                            outlined></v-text-field>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="onCancel()" :disabled="loading" text>Cancel</v-btn>
                    <v-btn @click="onSubmit()" color="primary" text :loading="loading" :disabled="canSubmit">Submit</v-btn>

                </v-card-actions>
            </v-card>



        </v-dialog>
    </div>
</template>


<script>

import {
    mapState,
    mapMutations
} from 'vuex'
import { actionEvent } from '../../../../../shared/constants/action-event'
import { validator } from '../../../../../shared/constants/validator'


export default {
    name: 'UserCreditForm',
    props: {

    },

    data: () => ({
        show: false,
        loading: false,
        form: Object.assign({}, {
            id: '',
            password: '',
            confirmPassword: ''
        }),
        formSetting: {
            valid: false,
            showPassword: false,
            showConfirmPassword: false,

        },
        validatorSetting: {
            password: validator.password,

        },

    }),
    computed: {
        canSubmit() {
            if (!this.formSetting.valid) return true;
            if (!this.samePassword) return true;
            return false
        },
        samePassword: {

            get() {
                return this.form.password === this.form.confirmPassword
            },

        },

    },
    methods: {
        ...mapMutations({
            setDialog: 'SET_DIALOG',
        }),
        onSubmit() {
            const { password } = this.form;

            this.loading = true;

            this.$axios.request({
                url: `users/${this.form.id}/resetPassword`,
                method: actionEvent.PUT,
                data: {
                    password
                }
            }).then((resp) => {
                this.setDialog({
                    title: 'Password Reset Success',
                    message: "User's password had reset",
                    show: true,
                    callback: () => {
                        this.show = false;
                    }
                })
            }).catch((err) => {
                const { data } = err.response;
                console.log(err)
                this.setDialog({
                    title: `Fail to reset user's password`,
                    message: data.message,
                    show: true,
                    callback: null,
                })
            }).finally(() => {
                this.loading = false;
            })

        },
        onCancel() {
            this.show = false
        },
        setForm({ user }) {
            this.mode = actionEvent.PUT;
            this.show = true;
            this.loading = false;
            this.form = Object.assign({}, {
                id: '',
                password: '',
                confirmPassword: ''
            })
            this.form.id = user.id;

        }
    },
    created() {

    },
    mounted() {

    },

}
</script>

<style></style>